import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RawInvertersResponse, RawInverterResponseWrapper } from '../types/inverter';
import type { RequestOptions } from '../types/common';

export function createInverterApi(http: Http) {
  return {
    async list(includes?: string, options?: RequestOptions): Promise<RawInvertersResponse> {
      const res = await http.get<RawInvertersResponse>(endpoints.inverter.base, {
        params: includes !== undefined ? { includes } : undefined,
        signal: options?.signal,
      });
      return res.data;
    },

    async detail(
      inverterId: number,
      includes?: string,
      options?: RequestOptions,
    ): Promise<RawInverterResponseWrapper> {
      const res = await http.get<RawInverterResponseWrapper>(endpoints.inverter.byId(inverterId), {
        params: includes !== undefined ? { includes } : undefined,
        signal: options?.signal,
      });
      return res.data;
    },

    async byPlant(
      plantId: number,
      includes?: string,
      options?: RequestOptions,
    ): Promise<RawInvertersResponse> {
      const res = await http.get<RawInvertersResponse>(endpoints.inverter.byPlant(plantId), {
        params: includes !== undefined ? { includes } : undefined,
        signal: options?.signal,
      });
      return res.data;
    },

    async byPlantAndId(
      plantId: number,
      inverterId: number,
      includes?: string,
      options?: RequestOptions,
    ): Promise<RawInverterResponseWrapper> {
      const res = await http.get<RawInverterResponseWrapper>(
        endpoints.inverter.byPlantAndId(plantId, inverterId),
        {
          params: includes !== undefined ? { includes } : undefined,
          signal: options?.signal,
        },
      );
      return res.data;
    },
  };
}
